import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { TenantFacade } from './tenant.facade';

/**
 * Synchronously rehydrates persisted tenant theme + branding before the app
 * paints. Add to `app.config.ts`'s `providers` so the very first render is
 * already branded — no flash of default Aura colors.
 *
 * The matching network refresh happens later from the login page (via
 * `TenantFacade.loadDomainData()`) so the cache stays warm.
 */
export function provideTenantBootstrap(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      inject(TenantFacade).bootstrap();
    }),
  ]);
}
